import { createSlice } from '@reduxjs/toolkit'
import name from './name'

const initialState = {
  catalogList: [],
  catalogListTotal: undefined
}

// Store
export const promotedContent = createSlice({
  name,
  initialState,
  reducers: {
    getTenantContent: (state, { payload: { content, total } }) => {
      state.catalogList = content
      state.catalogListTotal = total
    },
    fetchTenantContent: (state, { payload: { content, total } }) => {
      state.catalogList = state.catalogList.concat(content)
      state.catalogListTotal = total
    },
    reset: () => initialState
  }
})

export const {
  getTenantContent,
  fetchTenantContent,
  reset
} = promotedContent.actions

export default promotedContent.reducer
